/**
 * Whether the user has asked their OS to minimise animation.
 *
 * Read at the moment an animation is about to be configured rather than kept
 * as a reactive ref: nothing in the app restyles itself mid-animation, and a
 * plain function is usable from non-component code (`useProductTour` reads it
 * while building a driver.js config).
 *
 * `matchMedia` is guarded because jsdom-based unit tests do not implement it.
 */
export function prefersReducedMotion(): boolean {
  return (
    window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
  )
}
